import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import styles from './Subprocessors.module.css';

import Container from '../../../blocks/Container';

const Subprocessors = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/subprocessors.md/" } }) {
        edges {
          node {
            html
          }
        }
      }
    }
  `);

  const { html } = data.allMarkdownRemark.edges[0].node;

  return (
    <div className={styles.subprocessors}>
      <Container type="big">
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </Container>
    </div>
  )
};

export default Subprocessors;